import numeral from 'numeral'
import 'numeral/locales/ru'

numeral.locales.ru.delimiters.decimal = '.'
numeral.locale('ru')

export { numeral }
